import axios from 'axios';
import {apiUrl} from './apiAmbiente';
import {CHAVE_SESSAO} from './sessaoUsuario';

export async function consultarDashboard(acao = 'painel', idagenda, parametros = {}) {
  const token = sessionStorage.getItem(CHAVE_SESSAO);
  if (!token || token === 'null') throw new Error('Sua sessão expirou. Entre novamente.');
  const form = new FormData();
  form.set('token', token); form.set('acao', acao);
  if (idagenda !== undefined) form.set('idagenda', String(idagenda));
  if (acao === 'justificar') {
    form.set('assinatura', parametros.assinatura || '');
    form.set('justificativa', parametros.justificativa || '');
  }
  try {
    const {data} = await axios.post(apiUrl('DashboardRecepcao.php'), form, {timeout: 20000});
    if (!data?.ok) throw new Error(data?.erro || 'Não foi possível consultar o painel.');
    return data;
  } catch (e) {
    const msg = e.response?.data?.erro || e.message;
    throw new Error(typeof msg === 'string' ? msg : 'Não foi possível consultar o painel.');
  }
}

export const STATUS_PAINEL = {
  inicial: 'Agendado', espera: 'Lista de espera', atrasado: 'Ainda não chegou',
  aguardando: 'Aguardando', aguardandodmais: 'Esperando há muito tempo',
  atendimento: 'Em atendimento', finalizado: 'Finalizado', faltou: 'Não veio',
  cancelado: 'Cancelado', bloqueado: 'Bloqueado'
};
export function dataPainel(valor, hora = false) {
  const s = String(valor || '');
  if (!/^\d{4}-\d{2}-\d{2}/.test(s)) return '—';
  return s.slice(8, 10) + '/' + s.slice(5, 7) + (hora ? ' · ' + s.slice(11, 16) : '');
}
export const quantidadePainel = valor => new Intl.NumberFormat('pt-BR', {maximumFractionDigits: 3}).format(Number(valor) || 0);
